<template>
  <v-dialog
    :value="active"
    max-width="870"
    @input="$emit('update:active', $event)">
    <v-card>
      <div class="grey lighten-3 _fs-20 _fs-sm-24 pa-4">
        สำหรับลูกค้าที่ชำระผ่าน LINE Thailand
      </div>

      <div class="pa-4">
        <!-- eslint-disable-next-line max-len -->
        <div>1.  ทาง  Sellsuki จะมีการตัดรอบการเข้า Agency <b class="error--text"><u>ทุกๆวันที่ 15 ของทุกเดือน</u></b></div>
        <div class="error--text">
          (หากชำระเงินช้ากว่าวันดังกล่าว  ระบบจะตัดรอบการย้ายบัญชีไปรอบเดือนถัดไปทันที)
        </div>
        <!-- eslint-disable-next-line max-len -->
        <div>2.  สำหรับลูกค้าที่ Plan อยู่ให้ กดปุ่ม Downgrade เป็น Plan Free เพื่อป้องกันการตัดบัตรในเดือนถัดไป</div>
        <!-- eslint-disable-next-line max-len -->
        <div>3.  สำหรับลูกค้าที่มีแพ็กเกจอยู่ จะไม่สามารถเข้า Agency ได้ในทันที ซึ่งทางเราจะดำเนินการนำบัญชีเข้า Agency ในเดือนถัดไป</div>
        <!-- eslint-disable-next-line max-len -->
        <div>4.  หลังจากชำระเงินและได้รับเมลแจ้งอนุมัติแล้ว จะมีปุ่มให้กด <b class="success--text">เปลี่ยนการชำระเงิน</b> ที่ระบบ LINE Official Account ของท่าน กรุณาดำเนินการ<b class="error--text"><u>ก่อนวันที่ 29 ของทุกเดือน ก่อนเวลา 18.00 น. (สามารถตรวจสอบได้ที่อีเมลแจ้งอนุมัติการชำระเงิน)</u></b></div>
        <!-- eslint-disable-next-line max-len -->
        <div>5.  หลังจากดำเนินการนำบัญชีเข้าระบบ Agency เสร็จสิ้นแล้ว บัญชีของท่านจึงจะสามารถใช้งานแพ็กเกจตามที่สั่งซื้อได้</div>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="grey--text"
          text
          @click="$emit('cancel')">
          ปิด
        </v-btn>

        <v-btn
          color="primary"
          text
          @click="$emit('accept')">
          ยอมรับ
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable max-len */
export default {
  name: 'OrderLineThailand',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
